@if (locationForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="locationForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Location Direction </label>
            </div>
            <mat-button-toggle-group #directionToggle="matButtonToggleGroup" formControlName="direction"
              class="control-input select_spacer control-toggle-group" multiple="false"
              (change)="directionChange(directionToggle)"
              hideSingleSelectionIndicator>
              <mat-button-toggle value="inbound">Inbound</mat-button-toggle>
              <mat-button-toggle value="outbound">Outbound</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          @switch (locationForm.controls['direction'].value) {
            @case ('inbound') {
              <ng-container [ngTemplateOutlet]="inboundForm"></ng-container>
            }
            @case ('outbound') {
              <ng-container [ngTemplateOutlet]="outboundForm"></ng-container>
            }
          }
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Logic
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="locationForm">
          <div class="control-div">
            <label class="control-label"> Point To </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
            @if (nodeFlowDetails) {
              <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                [name]="'next'"
                [form]="locationForm"
                [stepId]="nodeFlowDetails.stepId">
              </next-selector>
            }
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #inboundForm>
  <ng-container [formGroup]="locationForm">

    <div class="control-div">
      <div class="control-label-container">
        <label class="control-label"> Name </label>
      </div>
      <clickatell-form-validation [controlName]="'name'" [form]="locationForm"></clickatell-form-validation>
      <input class="control-input" activeForm [activeForm]="locationForm" id="inboundName"
        [formControlName]="'name'"
        placeholder="Enter name"/>
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Text </label>
        </div>

        <clickatell-form-validation [controlName]="'text'" [form]="locationForm"></clickatell-form-validation>
        <textarea class="control-textArea" activeForm [activeForm]="locationForm" id="text"
          [formControlName]="'text'"
        placeholder="Enter text"></textarea>
      </div>

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Header </label>
        </div>
        <ng-container [ngTemplateOutlet]="header"></ng-container>
      </div>

    </ng-container>
  </ng-template>

  <ng-template #outboundForm>
    <ng-container [formGroup]="locationForm">

      <div class="control-div">
        <div class="control-label-container">
          <label class="control-label"> Name </label>
        </div>
        <clickatell-form-validation [controlName]="'name'" [form]="locationForm"></clickatell-form-validation>
        <input class="control-input" activeForm [activeForm]="locationForm" id="outboundName"
          [formControlName]="'name'"
          placeholder="Enter name"/>
        </div>

        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Description </label>
          </div>
          <clickatell-form-validation [controlName]="'bodyText'" [form]="locationForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="locationForm" id="bodyText"
            [formControlName]="'bodyText'"
            placeholder="Enter description"/>
          </div>

          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Latitude </label>
            </div>
            <clickatell-form-validation [controlName]="'locationLatitude'"
            [form]="locationForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="locationForm" id="locationLatitude"
              [formControlName]="'locationLatitude'"
              placeholder="E.g. -33.8811"/>
            </div>

            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Longitude </label>
              </div>
              <clickatell-form-validation [controlName]="'locationLongitude'"
              [form]="locationForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="locationForm" id="locationLongitude"
                [formControlName]="'locationLongitude'"
                placeholder="E.g. 18.63561"/>
              </div>

              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Location Name </label>
                </div>
                <clickatell-form-validation [controlName]="'locationName'"
                [form]="locationForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="locationForm" id="locationName"
                  [formControlName]="'locationName'"
                  placeholder="Enter location name"/>
                </div>

                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Location Address </label>
                  </div>
                  <clickatell-form-validation [controlName]="'locationAddress'"
                  [form]="locationForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="locationForm" id="locationAddress"
                    [formControlName]="'locationAddress'"
                    placeholder="Enter location address"/>
                  </div>


                </ng-container>
              </ng-template>

              <ng-template #header>
                <ng-container [formGroup]="locationForm">
                  <div class="control-div">
                    <mat-button-toggle-group #headerToggle="matButtonToggleGroup" [value]="selectedHeaderType"
                      class="control-input select_spacer control-toggle-group" multiple="false"
                      (change)="headerChange(headerToggle)"
                      hideSingleSelectionIndicator>
                      <mat-button-toggle value="text">Text</mat-button-toggle>
                      <mat-button-toggle value="media">Media</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>

                  @switch (selectedHeaderType) {
                    @case ('text') {
                      <div class="control-div">
                        <div class="control-label-container">
                          <label class="control-label"> Header </label>
                          <label class="control-optional">Optional</label>
                        </div>
                        <input class="control-input" activeForm [activeForm]="locationForm" id="header"
                          [formControlName]="'header'"
                          placeholder="Enter header"/>
                        </div>
                      }
                      @case ('media') {
                        <app-select-media-toggle [formGroup]="locationForm" id="imagRef"
                        [formControlName]="'imageRef'" [mediaFilter]="'image'"></app-select-media-toggle>
                      }
                    }
                  </ng-container>
                </ng-template>
